import React from "react";
import { graphql } from "gatsby";

import SaleCard from "../components/SaleCard";
import SectionTitle from "../components/SectionTitle";

const UpcomingSales: React.FC<{
  sales: readonly Queries.UpcomingSalesSaleFragment[];
}> = ({ sales }) => {
  return (
    <div className="mx-auto mb-16 max-w-[1200px]">
      <SectionTitle id="current-sales" className="px-4 lg:mb-8">
        Upcoming Sales
      </SectionTitle>
      <div className="overflow-x-auto p-4">
        {sales.length > 0 ? (
          <div className="grid w-[1168px] grid-cols-4 gap-8 lg:w-full">
            {sales.map((sale) => (
              <SaleCard key={sale.id} sale={sale} />
            ))}
          </div>
        ) : (
          <div className="flex h-full items-center justify-center lg:px-8">
            <p className="mb-0 max-w-[340px] text-center">
              It looks like there aren&apos;t any upcoming sales. Check back
              later for more information!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export const UpcomingSalesFragment = graphql`
  fragment UpcomingSalesSale on ContentfulSale {
    id
    ...SaleCardSale
  }
`;

export default UpcomingSales;
